<template>
  <div class="ui top attached label" :style="{ 'background-color': backGroundColor, 'width': '100%'}">
    <div class="ui stackable grid form" style="width: 100% !important">
      <div :class="columnsNumber[0]">
        <h2 class="ui header left floated" style="color: white">
          <i class="icon" :class="headerIcon" v-if="hasIcon"></i>
          <slot name="header-group-icons"></slot>

          <div class="content">
            {{ headerText }}
          </div>
        </h2>
      </div>

      <div :class="columnsNumber[1]"></div>

      <div :class="columnsNumber[2]">
        <div class="field" v-if="haveFilterInput">
          <div class="ui right labeled fluid input" style="margin-left: 5%;">
            <input type="text" :placeholder="`${$t('searchBy')} . . . . . . .`" v-model="filterString">
            <div class="ui dropdown label">
              <div class="text">{{ $t('searchBy') }}</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div class="item"
                     v-for="object in dropdownData"
                     v-if="object.filterable"
                     @click="columnName = object[props.value]">
                  {{ object[props.headerName] }}
                </div>
              </div>
            </div>
            <div class="ui button" id="search-btn" @click="riaseStartSearchingFlag">
              {{ $t('search') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dropdownData: { type: Array, default: () => { return [] } },
    backGroundColor: { type: String, default: '#0a3a5d' },
    props: { type: Object, default: () => { return {} } },
    headerIcon: { type: String, required: this.hasIcon },
    headerText: { type: String, required: true },
    haveFilterInput: { type: Boolean, default: false },
    columnsNumber: {
      type: Array,
      default: () => {
        return ['five wide column', 'three wide column', 'eight wide column']
      }
    },
    hasIcon: { type: Boolean, default: true }
  },
  data () {
    return {
      filterString: '',
      columnName: 'all'
    }
  },
  watch: {
    filterString: function () {
      this.$emit('filterString', { data: this.filterString })
    },
    columnName: function () {
      this.$emit('columnName', { data: this.columnName })
    },
    haveFilterInput: function () {
      if (this.haveFilterInput) {
        this.$nextTick(() => {
          $('.ui.dropdown').dropdown()
        })
      }
    }
  },
  mounted () {
    if (this.haveFilterInput) {
      this.$nextTick(() => {
        $('.ui.dropdown').dropdown()
      })
    }
    this.$emit('columnName', { data: this.columnName })
  },
  methods: {
    riaseStartSearchingFlag () {
      this.$emit('startSearchingProcess')
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/abstract_components/PageHeader.vue